import { cx } from "class-variance-authority";

import { Skeleton } from "../Skeleton/Skeleton";

import * as styles from "./CardSkeleton.module.scss";

type CardSkeletonProps = {
  className?: string;
};

export const CardSkeleton = ({ className }: CardSkeletonProps) => {
  return (
    <div className={cx(styles.card, className)}>
      <Skeleton mode="light" shape="circle" size="sm" />
      <div className={styles.details}>
        <Skeleton mode="light" edge="hard" size="sm" />
        <Skeleton mode="light" edge="hard" size="xs" span="half" />
        <Skeleton mode="light" edge="hard" size="xs" span="quart" />
      </div>
    </div>
  );
};
